import { CellValueChangedEvent, GridApi, GridReadyEvent, RowClassParams } from 'ag-grid-community';
import { ReactNode, useEffect, useState } from 'react';
import { getColumnDefinitions } from './columnDefinitions';

import styles from './OfferTariffTable.module.scss';
import { AgGridReact } from 'ag-grid-react';

export type TariffRow = {
  id: string;
  product: ReactNode;
  label?: ReactNode;
  price?: ReactNode;
  actionComponent?: ReactNode;
  highMoneyAmount?: string | ReactNode;
  entitlement?: ReactNode;
  addedRiskAmount?: number;
};

type TariffProps = {
  allowEditing?: boolean;
  tariffs: Array<TariffRow>;
  onTariffEdit?: (event: CellValueChangedEvent<TariffRow>) => void;
  summaryRow: TariffRow;
  partnerId: string;
};

export const OfferTariffTable = ({
  allowEditing = true,
  tariffs,
  summaryRow,
  onTariffEdit
}: TariffProps) => {
  const [gridApi, setGridApi] = useState<GridApi>();

  useEffect(() => {
    gridApi?.setGridOption('rowData', tariffs);
  }, [tariffs.length]);

  const handleGridReady = (event: GridReadyEvent) => {
    event.api.sizeColumnsToFit();
    setGridApi(event.api);
  };

  const handleCellEdit = (event: CellValueChangedEvent<TariffRow>) => {
    if (allowEditing) onTariffEdit?.(event);
  };

  return (
    <div>
      <AgGridReact
        columnDefs={getColumnDefinitions(allowEditing)}
        onCellValueChanged={handleCellEdit}
        rowData={[...tariffs, summaryRow]}
        onGridReady={handleGridReady}
        enableCellTextSelection={false}
        suppressDragLeaveHidesColumns
        tooltipShowDelay={0}
        ensureDomOrder
        getRowClass={(params: RowClassParams) => {
          const isLastRow =
            params.node && params.node.rowIndex === params.api.getDisplayedRowCount() - 1;
          return isLastRow ? styles.lastRow : styles.row;
        }}
        detailRowAutoHeight={true}
        defaultColDef={{
          sortable: false,
          suppressSizeToFit: false,
          autoHeight: true,
          suppressMovable: true
        }}
        domLayout={'autoHeight'}
      />
    </div>
  );
};
